<template>
    <div class="remove-wrapper" :class="{'content-wrapper':remove == false}">
    <div class="row hide-title">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          v-if="remove == false"
          :page-title="$t('task_detail')"
          :icon="'grid'"
        />
      </div>
    </div>
    <app-tab :tabs="tabsHorizontal" type="horizontal" />
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
// import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
// import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "Tabs",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  props: {
    tableId: String,
    id: [Number, String],
    afterSubmitDone:Function,
    remove: Boolean,
  },
  data() {
    return {
      modalId: "my_task_modal",
      icon: "settings",
      isAddEditModalActive: false,
      // title: '',
      tabsHorizontal: [
        {
          icon: "info",
          name: "Detail",
          component: "task-detail",
          permission: true,
          props: {id:this.id, tableId:this.tableId, refresh:this.afterSubmitDone}
        },
        {
          icon: "link",
          name: localStorage.getItem('type_value') == "questionnaire" ? "Questionnaire" : 'Form',
          component: "task-form-mainstep",
          permission: true,
          props: {id:this.id, tableId:this.tableId, refresh:this.afterSubmitDone}
        },
        {
          icon: "paperclip",
          name: "Upload document",
          component: "task-attach-document",
          permission: true,
          props: {id:this.id},
          style: 'float: right',
        },
        {
          icon: "paperclip",
          name: "Attach Save Responses Form",
          component: "task-attach-questionnaire",
          permission: true,
          props: {id:this.id}
        },
        {
          icon: "paperclip",
          name: "Endorsement",
          component: "task-endorsement-message",
          permission: true,
          props: {id:this.id}
        },
        {
          icon: "form",
          name: "Report",
          component: "task-report-index",
          permission: true,
          props: {id:this.id}
        },
      ],
    };
  },
  mounted() {
    this.$store.commit('updateSharedData', {index: "taskId", newValue: this.id})
    if (this.userRole.role == 'Supplier') {
          this.tabsHorizontal.forEach((element) => {
            if (element.name == "Endorsement") {
              element.permission = false;
            }
            if (element.name == "Attach Save Responses Form") {
              element.permission = false;
            }
          });
      }

  },
  watch:{
      runTitle() {
          console.log("this title ==",this.$store.state.taskformtype.type);
          // this.title = this.$store.state.taskformtype.type;
        }
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  
  },
};
</script>
